import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { UpdateBusinessCategoryComponent } from './update-business-category/update-business-category.component'
import { CreateBusinessCategoryComponent } from './create-business-category/create-business-category.component'
import { BusinessCategoriesComponent } from './business-categories.component'
import { businessCategoriesRoutes } from './business-categories.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '../../shared/shared.module'
import { CreateBusinessSubcategoryComponent } from './create-business-subcategory/create-business-subcategory.component'
import { UpdateBusinessSubcategoryComponent } from './update-business-subcategory/update-business-subcategory.component'
import { PropertyTypeModalModule } from '@components/property-type-modal/property-type-modal.module'
import { ContentLoadingModule } from '@components/content-loading/content-loading.module'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [
    BusinessCategoriesComponent,
    CreateBusinessCategoryComponent,
    UpdateBusinessCategoryComponent,
    CreateBusinessSubcategoryComponent,
    UpdateBusinessSubcategoryComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(businessCategoriesRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
    PropertyTypeModalModule,
    ContentLoadingModule,
    BreadcrumbsModule,
  ],
  exports: [
    BusinessCategoriesComponent,
    CreateBusinessCategoryComponent,
    UpdateBusinessCategoryComponent,
  ],
})
export class BusinessCategoriesModule {}
